import { determineFullTradeData } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { returnSizeFormatted } from "@/lib/globalFormatterHelper";
import tradeDataStore from "@/store/tradeDataStore";
import React, { useEffect, useState } from "react";

const QuotedSizeLegRP = (params: any) => {
  const fullTradeData = determineFullTradeData(params);
  const [initialValue, setInitialValue] = useState(params.value);

  const currentTradeData = tradeDataStore((state) => state.tradeData);
  const thisTrade = currentTradeData.find(
    (trade) => trade.esid == fullTradeData.esid,
  );

  // This trade will always be RP - Legs on thisTrade
  const thisLeg = thisTrade?.legs?.find(
    (leg) => leg.blockId == params.data.blockId,
  );
  useEffect(() => {
    if (zustandQuotedSize != initialValue) {
      params.api.flashCells({
        rowNodes: [params.node],
        columns: [params.column],
        flashDuration: 1000, // Optional: 1 second flash
        fadeDuration: 500, // Optional: 0.5 second fade
      });
      setInitialValue(zustandQuotedSize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTradeData]);

  const zustandQuotedSize = thisLeg?.quotedSize || 0;

  const returnValue = zustandQuotedSize
    ? returnSizeFormatted(zustandQuotedSize, params.data.instrumentType)
    : "";

  return <div data-testid="QuotedSizeLegRPContainer">{returnValue}</div>;
};

export default QuotedSizeLegRP;
